"use client";

import React from "react";
import { Box, Map, Leaf } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "01/ SAFETY",
  description: "Rigorous risk assessments and temporary power solutions designed to protect personnel and equipment from day one.",
  icon: Box
}, {
  title: "02/ EFFICIENCY",
  description: "Streamlined site preparation that eliminates downtime, ensuring your electrical infrastructure is ready for immediate deployment.",
  icon: Map
}, {
  title: "03/ PRECISION",
  description: "Technical accuracy in every distribution board and cable run, built to exact industrial specifications and blueprints.",
  icon: Leaf
}];
export default function PourquoiBoxify() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224452" id="the-gridspan-advantage" className="dark bg-background text-foreground py-24 px-6 md:px-12 lg:px-24 overflow-hidden border-y border-border/10">
      <div className="max-w-7xl mx-auto">
        <div className={`flex flex-col items-center text-center mb-16 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold tracking-tighter mb-6 uppercase">
            The Gridspan Advantage
          </h2>
          <Separator className="w-24 h-1 bg-primary rounded-none" />
        </div>

        <div ref={ref} className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <div key={i} data-index={i} className={`transition-all duration-700 ease-out delay-${i * 200} ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
                <Card className="h-full bg-secondary/10 border-border/20 rounded-none shadow-none hover:border-primary/50 transition-all duration-300 flex flex-col items-center text-center group">
                  <CardHeader className="pt-10 pb-4 flex flex-col items-center gap-4">
                    <div className="p-4 rounded-none bg-primary/10 text-primary mb-2 border border-primary/30 group-hover:bg-primary group-hover:text-primary-foreground transition-all duration-300">
                      <Icon size={48} strokeWidth={1.5} />
                    </div>
                    <CardTitle className="font-mono text-sm md:text-base font-bold tracking-widest text-primary uppercase">
                      {feature.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="pb-10 px-8">
                    <p className="font-default text-muted-foreground leading-relaxed text-sm md:text-base">
                      {feature.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}